module.exports = __webpack_public_path__ + "img/img-bg-color-s1.ed701e9e.jpg";